module.exports = __webpack_public_path__ + "static/media/John Wallace.e2eabd5a.png";